import React, { useRef, useEffect, useState } from 'react';
import axios from 'axios';
import useInterval from '@use-it/interval';
import { setVideoPlayerPlaying } from '../actions'
import { useDispatch, useSelector } from 'react-redux'
//import videojs from 'video.js'
import HtmlContent from "src/shared/html_content"
import VideoPlayerOverlay from 'src/shared/video/video_room/player/video_player_overlay.jsx'
import {VelocityTransitionGroup, VelocityComponent} from 'velocity-react';
require('velocity-animate');
require('velocity-animate/velocity.ui');
//import videojs from 'video.js'
//import 'videojs-vr/dist/videojs-vr.min.js'



export default function PolyPlayer({ videoRoom, streamSource, entranceRepeatTime, playerConfig, ...props }) {

  const entranceUrl = props.entranceUrl
  const videoPlayerPlaying = useSelector(state => state.videoPlayerPlaying)
  const videoNode = useRef(null)
  const player = useRef(null)
  const dispatch = useDispatch()

  // needed because videojs dispose removes the dom element

  const [ended, setEnded] = useState(false)

  const configPlayer = () => {
    console.log("Starting player with", streamSource, playerConfig)
    player.current = polyvObject('#player').livePlayer(playerConfig)
    //   videojs(videoNode.current, { sources: [{src: streamSource}]}, function onPlayerReady() {
    //   console.debug('onPlayerReady', this)
    // })
    // player.current.on("ended", () => {
    //   console.debug("ENDED")
    //   setEnded(true)
    // })
    // player.current.on("play", () => {
    //   console.debug("PLAYING")
    //   setEnded(false)
    // })
    // player.current.on("seeked", () => {
    //   console.debug("PLAYING")
    //   setEnded(false)
    // })    

    // if(playerConfig?.projection360) {
    //   console.warn("Enabling 360 player")
    //   player.current.vr({projection: '360'});
    // }
  }
 
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://player.polyv.net/livescript/liveplayer.js';
    script.async = true;
    document.body.appendChild(script);
    script.onload = configPlayer

    // if(playerConfig?.projection360) {
    //   script.onload = () => {
    //     const script2 = document.createElement('script');
    //     script2.src = 'https://cdn.jsdelivr.net/npm/videojs-vr@1.7.1/dist/videojs-vr.min.js';
    //     script2.async = true;
    //     document.body.appendChild(script2);
    //     script2.onload = configPlayer
    //   }
    // } else {
    //   script.onload = configPlayer
    // }

    return () => {
      if(player.current) {
        player.current.destroy()
      }
    }
      
  }, [streamSource])

  useInterval(() => {
    // if(player?.current && !player?.current?.paused()) {
    //   if(!videoPlayerPlaying){
    //     dispatch(setVideoPlayerPlaying(true))
    //   }
    //   console.warn("playing")
    // } else {
    //   if(videoPlayerPlaying){
    //     dispatch(setVideoPlayerPlaying(false))
    //   }
    //   console.warn("Not playing")
    // }
  }, 3000);

  return (
      <div className="flave-video-container">
        <div
          onClick={props.onPlayerClick}
          className="videojs_player_container"
          style={{width: "100%", position: "relative", backgroundColor: "black", minHeight: "30px"}}>
            <div id="player"></div>
            {props.children}
          </div>
      </div>
  )
}
